import React from 'react';
import { Pagination, Select } from 'antd';
import { useTranslation } from 'react-i18next';

export default function CustomPagination({ 
  current, 
  pageSize, 
  total, 
  onChange, 
  pageSizeOptions = [8, 16, 24, 32, 40],
  className = "esi-std-pagination"
}) {
  const { t } = useTranslation();

  return (
    <Pagination
      className={className}
      current={current}
      pageSize={pageSize}
      total={total}
      onChange={(page, limit) => {
        if (onChange) {
          onChange(page, limit);
        }
      }}
      showSizeChanger={false}
      showQuickJumper={true}
      locale={{
        items_per_page: t('text_item_page'),
        jump_to: t('text_jump'),
        jump_to_confirm: t('text_sure'),
        page: '',
        prev_page: t('text_previous_page'),
        next_page: t('text_next_page'),
        prev_5: t('text_5_page_next'),
        next_5: t('text_5_page_previous'),
        prev_3: t('text_3_page_next'),
        next_3: t('text_3_page_previous'),
        page_size: t('text_page_num')
      }}
      showTotal={() => (
        <Select
          value={pageSize}
          onChange={(val) => {
            if (onChange) {
              onChange(1, val);
            }
          }}
          options={pageSizeOptions.map(size => ({ value: size, label: `${size}/${t("text_page")}` }))}
          className="mr-4"
          bordered={true}
        />
      )}
    />
  );
}
